<template>
    <div class="container p-5">
        <h1><strong>Страница для проверки sentry</strong></h1>
        <p><b-button variant="primary" @click="test">Вызвать ошибку 1</b-button></p>
        <p><b-button variant="primary" @click="testtest">Вызвать ошибку 2</b-button></p>
        <p><b-button variant="primary" @click="test2">Вызвать ошибку 3</b-button></p>
        <p><router-link to="/">Вернуться назад</router-link></p>
    </div>
</template>


<script>
    export default {
        name: "SentryTest",

        methods: {
            test2() {
                testasetaest();
            },
            test() {
                testasetaest();
            }
        }
    };
</script>
